import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ngx-modal',
  styleUrls: ['./alert-modal.component.scss'],
  templateUrl: './alert-modal.component.html',
})
export class AlertModalComponent {

  modalHeader = 'Alert title';
  modalContent = ``;

  modalHtmlContent = null;
  modalOkText = 'OK';
  modalCancelText = 'Cancel';

  modalForceButton: string = null;
  modalForceDesc: string = null;

  modalCancelEnabled: boolean;

  @Output() action = new EventEmitter<boolean>();

  @Output() forced_action = new EventEmitter<boolean>();

  constructor(
    private activeModal: NgbActiveModal,
    protected modalService: NgbModal,
    private sanitizer: DomSanitizer,
  ) { }


  closeModal() {
    this.activeModal.close();
  }

  doSubmit() {
    this.action.emit(true);
    this.activeModal.close();
  }

  doForce() {
    this.forced_action.emit(true);
    this.activeModal.close();
  }

  doCancel() {
    this.action.emit(false);
    this.activeModal.close();
  }
}
